import { mapState, mapGetters, mapActions } from "vuex";

export const authComputed = {
  ...mapState("auth", {
    alertError: state => state.alertError,
    loggedIn: state => state.loggedIn,
    loggedUser: state => state.loggedUser
  })
};

export const authGetter = {
  ...mapGetters("auth", ["loggedIn", "getterAlertError", "redirectPathName", "loggedUser"])
};

export const specialityMethods = mapActions("speciality", [
  "fetchAllSpecialities",
  "fetchMostRequestedSpecialities"
]);

export const councilGetter = {
  ...mapGetters("council", ["councils"])
};

export const authMethods = mapActions("auth", [
  "login",
  "logout",
  "register",
  "forgotPassword",
  "updatePassword"
]);

export const councilMethods = mapActions("council", ["fetchAllCouncils"]);

export const userMethods = mapActions("user", [
  "updateUser",
  "updateAnOperator",
  "showUser",
  "fetchUsersAppointments",
  "emailVerification",
  "cpfVerification",
  "phoneNumberVerification",
  "showSymptoms",
  "addCreditCard",
  "fetchUserCreditCards",
  "deleteUserCreditCard",
  "tokenizeCreditCard",
  "updateUserCreditCard",
  "fetchInsuranceEnrollments",
]);

export const userComputed = {
  ...mapState("user", {
    currentUser: state => state.currentUser,
    userRole: state => state.userRole
  })
};

export const doctorMethods = mapActions("doctor", [
  "fetchDoctors",
  "updateDoctorProperties",
  "fetchDoctorsAvailables",
  "fetchDoctorsAppointments",
  "createRoom",
  "getDoctorDetails",
  "activateWireCardAccount",
  "getDoctorCoupons"
]);

export const roomMethods = mapActions("room", [
  "getRoomDetails",
  "selectRoom",
  "clearSelectedRoom",
  "createRoomV2",
  "getRoomDetailsV2",
]);

export const appointmentState = mapState("appointments", {
  appointment: state => state.appointment
});

export const appointmentsMethods = mapActions("appointments", [
  "scheduleAppointment",
  "cancelAppointment",
  "fetchAppointments",
  "holdScheduleAppointment",
  "clearScheduleAppointment",
  "fetchFutureAppointments",
  "fetchPastAppointments",
  "fetchCanceledAppointments",
]);

export const slotMethods = mapActions("slot", ["createSlot", "simpleCreate", "deleteSlot", "getConfig"]);

export const addressMethods = mapActions("address", [
  "createAddress",
  "updateAddress"
]);

export const operatorMethods = mapActions("operator", [
  "login",
  "register",
  "logoutOperator",
  "fetchUsersLocation",
  "fetchUserInstitutions",
  "fetchAlerts",
  "showAlert",
  "updateUserStatus",
  "fetchUserInstitutionSymptoms"
]);

export const reportsMethods = mapActions("reports", [
  "getNeighborhoodStatus",
  "getStatuses",
  "getCitiesStatuses"
]);

export const reportsComputed = {
  ...mapState("reports", {
    neighborhoods: state => state.neighborhoods,
    statuses: state => state.statuses,
    citiesStatuses: state => state.citiesStatuses
  })
};

export const faceRecognitionMethods = mapActions("faceRecognition", [
  "imageEnroll",
  "imageRecognize"
]);

export const operatorState = mapState("operator", {
  errorMessage: state => state.errorMessage
});

export const prescriptionMethods = mapActions("prescriptions", [
  "postPrescription"
]);
